// PopupDescription Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import Popover from '../../../common/common/popover/popover.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class PopupDescription extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      bShowEditor: false
    }

    this._references = {
      editor: React.createRef()
    }
  }

  static get propTypes () {
    return {
      container: PropTypes.any,
      description: PropTypes.string,
      onChange: PropTypes.func,
      target: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      container: null,
      description: '',
      onChange: null,
      target: null
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this._references.editor.current &&
      this.state.active &&
      prevState.active !== this.state.active
    ) {
      this._references.editor.current.focus()
    }
  }

  show () {
    this.setState({ active: true })
  }

  hide () {
    this.setState({ active: false })
  }

  render () {
    const classes = classnames('popup-description popup-form', {
      active: this.state.active
    })
    const { description, onChange } = this.props
    return (
      <Popover
        placement='bottom'
        container={this.props.container || this}
        target={this.props.target}
        show={this.state.active}
        onHide={this.hide.bind(this)}
      >
        <div className={classes}>
          <div className='popupheader'>
            <h3 className='title'>
              <IntlMessage ident='project.form.titleDescription' />
            </h3>
            <span className='action' onClick={this._onClickClose.bind(this)}>
              <i className='icon icon-popup-budgetclose' />
            </span>
          </div>
          <div className='popupcont'>
            <div className='descriptioncont'>
              <i
                className='icon icon-popup-budgetedit'
                onClick={this._onEditClick.bind(this)}
              />
              <WysiwygEditor
                placeholder='project.viewBudget.typeHere'
                ref={this._references.editor}
                value={description}
                onBlur={onChange}
                bShowLink={false}
              />
            </div>
          </div>
        </div>
      </Popover>
    )
  }

  /* Event handlers */
  _onEditClick () {
    this.setState({ bShowEditor: !this.state.bShowEditor })
  }

  _onClickClose () {
    this.hide()
  }
}

export default PopupDescription
